export default "__VITE_ASSET__BKslokT___"